import BaseController from 'app/src/controllers/base/BaseController';
import ModalView from 'app/src/views/components/ModalView';
import ModalFooterView from 'app/src/views/components/ModalFooterView';

export default class ModalViewController extends BaseController {
  /**
   * Constructor for a ModalViewController.  Intended to be overridden by a concrete modal
   * implementation which injects the delegate view.
   *
   * @param modalView {ModalView} The customized view to be presented as a modal.
   *
   * @param options {Object}  Options to configure the behaviour of the modal.  Supported
   *                          options include:
   *
   *                          {
   *                              title: string => The title to be displayed in the modal
   *                          }
   */
  constructor(modalView, options = {}) {
    if (!modalView) {
      throw 'A view must be specified when creating a DetailViewController';
    }

    super();

    this._modalView = modalView;
    this._options = options;
    this._buttons = [];

    this.view = new ModalView({
      viewData: {
        title: options.title,
        backButton: options.backButton,
      },
    });
  }

  /**
   * Called to show the view.  Renders the injected child view into the
   * content region.
   */
  show() {
    super.show();

    this.showChildView('content', this._modalView);
  }

  /**
   * Called when the modal is to be dismissed.
   */
  dismiss() {
    this.view.dismiss();
  }

  /**
   * Set the buttons that should appear in the modal
   *
   * @param {Array.string} buttons    The values of the buttons that should appear in the modal.  The
   *                                  values double as the ID of the button (at least for now)
   */
  setButtons(buttons) {
    if (buttons && buttons.length) {
      this._buttons = buttons;
      this.showChildView(
        'footer',
        new ModalFooterView({
          viewData: {
            buttons: this._buttons,
          },
        })
      );
      this.view.showFooter(true);
    } else {
      // if the buttons specified is empty or invalid then clear the footer
      this._buttons = [];
      this.view.getRegion('footer').empty();
      this.view.showFooter(false);
    }
  }
}
